<template>
  <b-card no-body>
    <el-table
      class="table-responsive table"
      header-row-class-name="thead-light"
      :data="data"
    >
      <el-table-column sortable label="ID" prop="name" min-width="90px">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-weight-600 name mb-0 text-sm">
                {{ row.id }}
              </span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        label="Nombre y Apellidos"
        min-width="200px"
        prop="date"
      >
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-weight-600 name mb-0 text-sm">{{
                row.nombre + " " + row.apellido1 + " " + row.apellido2
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      <el-table-column sortable label="Telefono" min-width="160px" prop="date">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-weight-600 name mb-0 text-sm">{{
                row.telefono
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        label="Fecha Nacimiento"
        min-width="170px"
        prop="date"
      >
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-weight-600 name mb-0 text-sm">{{
                fecha_nacimiento(row.fecha_nacimiento)
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      <el-table-column sortable label="profesion" min-width="200px" prop="date">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-weight-600 name mb-0 text-sm">{{
                row.profesion
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        label="correoElectronico"
        min-width="200px"
        prop="date"
      >
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-weight-600 name mb-0 text-sm">{{
                row.correoElectronico
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      <el-table-column label="Editar" min-width="150px" prop="date">
        <template v-slot="{ row }">
          <b-row>
            <b-col
              ><el-button
                type="primary"
                icon="el-icon-edit"
                circle
                @click="editarCatequista(row.id)"
              ></el-button
            ></b-col>
            <b-col
              ><el-button
                type="primary"
                icon="el-icon-delete"
                circle
                @click="eliminarCatequista(row.id)"
              ></el-button
            ></b-col>
          </b-row>
        </template>
      </el-table-column>
    </el-table>
  </b-card>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["data"],
  methods: {
    editarCatequista(idCatequista) {
      this.$emit("editarCatequista", idCatequista);
    },
    eliminarCatequista(idCatequista) {
      this.$bvModal
        .msgBoxConfirm("¿Desea elimiar a este catequista?", {
          title: "Eliminar Catequista",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Si",
          cancelTitle: "No",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.$emit("eliminarCatequista", idCatequista);
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },

    fecha_nacimiento(fecha) {
      if (fecha) {
        return fecha.split("-").reverse().join("/");
      }
    },
  },
};
</script>
<style scoped>
.separador {
  border-left: 1px solid rgb(2, 2, 2);
  height: auto;
}
</style>
